import React from "react";
import { motion } from "framer-motion";

const Home = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_background.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      className="bg-gray-100 h-screen w-full flex items-end justify-start px-8 pb-20 md:pb-24"
    >
      {/* Visually hidden primary H1 for SEO — screen reader accessible */}
      <h1 className="sr-only">
        Geetha Furniture — Furniture Manufacturer in Coimbatore | Executive Tables, Conference Tables, Workstations
      </h1>
      <div className="w-full md:w-1/2 text-left">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight"
        >
          Elevate your space with our elegant designs for everyday living
        </motion.h2>
      </div>
    </div>
  );
};

export default Home;
